import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, useTranslation } from 'react-i18next';

import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enPanel from './locales/en/panel.json';
import hiCommon from './locales/hi/common.json';
import hiLanding from './locales/hi/landing.json';
import hiPanel from './locales/hi/panel.json';

export const SUPPORTED_LANGUAGES = ['en', 'hi'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  en: 'English',
  hi: 'हिन्दी',
};

let initialized = false;

export function initI18n(): typeof i18n {
  if (initialized) return i18n;
  initialized = true;

  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: {
        en: { common: enCommon, landing: enLanding, panel: enPanel },
        hi: { common: hiCommon, landing: hiLanding, panel: hiPanel },
      },
      fallbackLng: 'en',
      supportedLngs: SUPPORTED_LANGUAGES,
      defaultNS: 'common',
      ns: ['common', 'landing', 'panel'],
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'kss.lang',
        caches: ['localStorage'],
      },
    });

  return i18n;
}

export function setLanguage(lang: SupportedLanguage): Promise<void> {
  return i18n.changeLanguage(lang).then(() => undefined);
}

export { i18n, useTranslation };
